import React from "react";
import Skeleton from "./Skeleton";

const BankRowSkeleton = () => (
  <tr className="bankSkeletonRow">
    <td className="bankSkeletonCell">
      <div className="bankSkeletonInfo">
        <Skeleton
          variant="card"
          width={34}
          height={34}
          borderRadius={8}
          className="bankSkeletonAvatar"
        />
        <Skeleton width={120} height={13} />
      </div>
    </td>
    <td className="bankSkeletonCell">
      <Skeleton width={110} height={13} />
    </td>
    <td className="bankSkeletonCell">
      <Skeleton width={140} height={13} />
    </td>
    <td className="bankSkeletonCell bankSkeletonAction">
      <Skeleton width={40} height={28} borderRadius={6} />
    </td>
  </tr>
);

export default BankRowSkeleton;
